import { render, staticRenderFns } from "./UsernameStatusText.vue?vue&type=template&id=8e6c5b6e&"
import script from "./UsernameStatusText.vue?vue&type=script&lang=js&"
export * from "./UsernameStatusText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports